// Full 14-category grid used at the top of the shops page + inside the
// customer's "Categories" tab. Layout matches the Talabya v2 mock — rounded
// squares (not circles) with a solid colored background, a white icon, and
// a small label below. Also exports `CATEGORY_TILES` so the RestaurantsList
// scoped grid + the admin Branches SHOP_TYPES can stay in lockstep.
import {
  UtensilsCrossed, Cake, Coffee, Pill, ShoppingBasket, Building2, Carrot,
  Beef, Smartphone, Home, Plug, Shirt, Sparkles, BookOpen, Grid3x3, Plus,
} from "lucide-react";

export const CATEGORY_TILES = [
  { value: "restaurant",    label: "مطاعم",           icon: UtensilsCrossed, bg: "bg-red-500"      },
  { value: "bakery_sweets", label: "مخابز وحلويات",   icon: Cake,            bg: "bg-orange-400"   },
  { value: "cafe",          label: "مقاهي",           icon: Coffee,          bg: "bg-amber-700"    },
  { value: "pharmacy",      label: "صيدليات",         icon: Pill,            bg: "bg-teal-500"     },
  { value: "grocery",       label: "مواد غذائية",     icon: ShoppingBasket,  bg: "bg-green-500"    },
  { value: "coop_market",   label: "تشاركيات",        icon: Building2,       bg: "bg-blue-600"     },
  { value: "vegetables",    label: "خضروات وفواكه",   icon: Carrot,          bg: "bg-lime-500"     },
  { value: "meat_poultry",  label: "لحوم ودواجن",     icon: Beef,            bg: "bg-red-600"      },
  { value: "phones",        label: "هواتف واكسسوارات", icon: Smartphone,     bg: "bg-indigo-600"   },
  { value: "household",     label: "مواد منزلية",     icon: Home,            bg: "bg-stone-700"    },
  { value: "electronics",   label: "إلكترونيات",      icon: Plug,            bg: "bg-teal-600"     },
  { value: "clothes",       label: "ملابس وأحذية",    icon: Shirt,           bg: "bg-pink-500"     },
  { value: "beauty",        label: "تجميل وعطور",     icon: Sparkles,        bg: "bg-purple-500"   },
  { value: "books",         label: "مكتبات وقرطاسية", icon: BookOpen,        bg: "bg-orange-500"   },
];

// "Any other" placeholder — clicking it filters to shop_type=other so
// admins can classify one-off shops under it.
export const OTHER_TILE = { value: "other", label: "أي شيء آخر", icon: Plus, bg: "bg-slate-100 text-slate-500 border-2 border-dashed border-slate-300" };

export default function CategoryGrid({ value, onChange, showAll = true, showOther = true, tiles = CATEGORY_TILES }) {
  return (
    <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 gap-3 sm:gap-4" data-testid="category-grid">
      {showAll && (
        <TileBtn
          active={!value}
          label="الكل"
          Icon={Grid3x3}
          bg="bg-blue-600"
          testId="cat-tile-all"
          onClick={() => onChange("")}
        />
      )}
      {tiles.map((c) => (
        <TileBtn
          key={c.value}
          active={value === c.value}
          label={c.label}
          Icon={c.icon}
          bg={c.bg}
          testId={`cat-tile-${c.value}`}
          onClick={() => onChange(c.value)}
        />
      ))}
      {showOther && (
        <TileBtn
          active={value === "other"}
          label={OTHER_TILE.label}
          Icon={OTHER_TILE.icon}
          bg={OTHER_TILE.bg}
          testId="cat-tile-other"
          onClick={() => onChange("other")}
        />
      )}
    </div>
  );
}

function TileBtn({ active, label, Icon, bg, testId, onClick }) {
  const isDashed = bg?.includes("border-dashed");
  return (
    <button onClick={onClick} data-testid={testId}
      className="group flex flex-col items-center gap-2 transition-transform hover:-translate-y-0.5 focus:outline-none"
    >
      <div className={`w-[64px] h-[64px] sm:w-[76px] sm:h-[76px] rounded-2xl flex items-center justify-center talabya-shadow-soft transition-transform group-hover:scale-105 ${bg} ${!isDashed ? "text-white" : ""} ${active ? "ring-4 ring-primary-brand ring-offset-2 ring-offset-[var(--background)]" : ""}`}>
        <Icon size={28} strokeWidth={2.2}/>
      </div>
      <div className={`text-[11px] sm:text-xs font-black text-center max-w-[86px] leading-tight ${active ? "text-primary-brand" : "text-[var(--text-primary)]"}`} style={{fontFamily:"Cairo"}}>
        {label}
      </div>
    </button>
  );
}
